import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import Keycloak from "keycloak-js";

const {
  VUE_APP_KC_CLIENT_ID: clientId,
  VUE_APP_KC_REALM: realm,
  VUE_APP_KC_URL: url,
} = process.env;

Vue.config.productionTip = false;

const keycloak = new Keycloak({
  url,
  realm,
  clientId,
});

Vue.prototype.$keycloak = keycloak;

const tokenInterceptor = () => {
  axios.interceptors.request.use(
    async (config) => {
      try {
        await keycloak.updateToken(30);
      } catch (error) {
        keycloak.login();
      }
      config.headers.Authorization = `Bearer ${keycloak.token}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

keycloak
  .init({ onLoad: "login-required", checkLoginIframe: false })
  .then(() => {
    if (!keycloak.hasResourceRole("admin")) {
      keycloak.logout();
      return;
    }
    tokenInterceptor();
    new Vue({
      router,
      render: (h) => h(App),
    }).$mount("#app");

    setInterval(() => {
      keycloak.updateToken(30).catch(() => keycloak.login());
    }, 10000);
  });
